var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKusama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F3F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69266 15.3798V15.5341C4.69266 15.5341 10.7087 13.3076 11.8782 13.8826L11.1727 14.0772C11.2345 14.0772 12.3778 14.1474 12.3778 14.1474C12.4046 14.3686 12.4834 14.5814 12.6087 14.7706C12.7339 14.9598 12.9024 15.1206 13.102 15.2413C13.7906 15.6674 13.8037 15.8988 13.8037 15.8988C13.8037 15.8988 13.4463 16.0355 13.4463 16.2091C13.7786 16.1199 14.1223 16.0734 14.468 16.0706C14.7798 16.081 15.089 16.1275 15.3886 16.2091C15.3886 16.2091 15.3531 16.0338 14.8721 15.8988C14.3912 15.7638 13.9272 15.2869 13.6933 15.0222C13.553 14.853 13.462 14.6525 13.4292 14.4405C13.3964 14.2285 13.4229 14.0121 13.5062 13.8125C13.6727 13.4128 14.2546 13.1902 15.4354 12.6151C16.8369 11.9367 17.1569 11.4282 17.3534 11.0373C17.5499 10.6463 17.8455 9.86269 18.0083 9.49453C18.1437 9.15041 18.3766 8.84736 18.682 8.61795C18.8897 8.46894 19.8365 8.13409 19.8365 8.13409C19.8365 8.13409 19.1142 7.5573 18.8784 7.38374C18.5838 7.12226 18.2111 6.95104 17.81 6.89286C17.3085 6.8315 16.7995 7.14356 16.4552 7.35218C16.1109 7.56081 15.4447 8.1709 15.1753 8.34622C14.9058 8.52153 14.2153 8.69685 13.1169 9.32622C12.0185 9.9556 7.65856 12.5625 7.65856 12.5625L8.7813 12.573L3.74208 15.0222H4.24545L3.51941 15.5481C3.92153 15.6344 4.34361 15.5742 4.70016 15.3798H4.69266Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKusama);
export default __webpack_public_path__ + "static/media/kusama.e9d77a700ecf2403f3632623b7ace17e.svg";
export { ForwardRef as ReactComponent };